
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-interior-design-app",
      function () {
        return require("private-next-pages/ai-interior-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-interior-design-app"])
      });
    }
  